import { Box } from "@mui/material";
import { grey } from "@mui/material/colors";
import { datatypes, inputTypes } from "data/globalData";

export const costingUrlKey = "costing_id";

export const openCostingFabricAssocObjKey = "openCostingFabric";
export const openCostingSewingTrimsAssocObjKey = "openCostingSewingTrims";
export const openCostingPackingTrimsAssocObjKey = "openCostingPackingTrims";
export const openCostingValueAddAssocObjKey = "openCostingValueAdd";
export const openCostingOtherChargesAssocObjkey = "openCostingOtherCharges";
export const openCostingPoCostAssocObjkey = "openCostingPoCost";

export const openCostingQtySizeSplitAssockey = "openCostingQtySizeSplit";
export const openCostingChannelWhSplitAssockey = "openCostingChannelWhSplit";

export const optionDetailsReqColumns = {
	style_ref_no: { NOTNULL: true, DISPLAY: true },
	style_name: { NOTNULL: true, DISPLAY: true },
	color: { NOTNULL: true, DISPLAY: true },
	pallete: { NOTNULL: true, DISPLAY: true },
	season: { NOTNULL: true, DISPLAY: true },
	brand: { NOTNULL: true, DISPLAY: true },
	sub_brand: { NOTNULL: false, DISPLAY: true },
	division: { NOTNULL: false, DISPLAY: true },
	category: { NOTNULL: true, DISPLAY: true },
	sub_category: { NOTNULL: false, DISPLAY: true },
};

export const filterRequiredStyleColumns = (styleAllAttributesObj) => {
	return Object.keys(optionDetailsReqColumns)?.reduce((acc, col) => {
		if (styleAllAttributesObj[col]) acc.push({ ...styleAllAttributesObj[col], constraints: optionDetailsReqColumns[col] });
		return acc;
	}, []);
};

export const totalQtyColumn = {
	name: "Total Qty",
	key: "total_qty",
	input_type: inputTypes.ENTER.key,
	constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
	data: {},
	data_type: datatypes.NUMBER.key,
	sort_no: 1,
	group: "",
	placeholder: "",
	default_value: 0,
	// [selectOptionsKeyName]: {
	// 	type: arrType,
	// 	list: [],
	// 	getOptionLabel: (opt) => ({ name: opt.style_id, key: opt.style_id }),
	// },
};
export const supplierColumn = {
	name: "Supplier",
	key: "supplier",
	input_type: inputTypes.ENTER.key,
	constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
	data: {},
	data_type: datatypes.STRING.key,
	sort_no: 1,
	group: "",
	placeholder: "",
	default_value: 0,
	// [selectOptionsKeyName]: {
	// 	type: arrType,
	// 	list: [],
	// 	getOptionLabel: (opt) => ({ name: opt.style_id, key: opt.style_id }),
	// },
};

export const DisabledBox = ({ field, row }) => {
	return (
		<Box width="100%" height="100%" display="flex" alignItems="center" justifyContent="center" sx={{ background: grey[100] }}>
			<span style={{ textTransform: "uppercase" }}>
				{typeof row[field] === "string" ? row[field]?.split("_").join(" ") : row[field]}
			</span>
		</Box>
	);
};
export const WhiteBgBox = ({ field, row }) => {
	return (
		<Box width="100%" height="100%" display="flex" alignItems="center" justifyContent="center" sx={{ background: "white" }}>
			<span style={{ textTransform: "uppercase" }}>
				{typeof row[field] === "string" ? row[field]?.split("_").join(" ") : row[field]}
			</span>
		</Box>
	);
};
export const TotalBox = ({ field, row }) => {
	return (
		<Box
			width="100%"
			height="100%"
			display="flex"
			alignItems="center"
			justifyContent="center"
			sx={{ background: grey[300], fontWeight: 600 }}>
			<span style={{ textTransform: "uppercase" }}>
				{typeof row[field] === "string" ? row[field]?.split("_").join(" ") : row[field]}
			</span>
		</Box>
	);
};

export const costingTableTypes = {
	fabric: { name: "Fabric", key: "fabric" },
	sewing_trims: { name: "Sewing Trims", key: "sewing_trims" },
	packing_trims: { name: "Packing Trims", key: "packing_trims" },
	carton_tape: { name: "Carton & Tape", key: "carton_tape" },
	value_add: { name: "Value Add", key: "value_add" },
	final_total: { name: "Final Total", key: "final_total" },
	po_cost: { name: "PO Cost", key: "po_cost" },
};
